import { render } from "./ChangeLogSimple.vue?vue&type=template&id=82c167b4"
import script from "./ChangeLogSimple.vue?vue&type=script&lang=js"
export * from "./ChangeLogSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__